import { useId } from 'react';
import { Select, SelectItem } from '../Select';
import type { SelectPortalProps } from '../Select/types';
import { Label } from '../Label';
import { cn } from '../../lib/utils';
import useI18n from '../../hooks/useI18n';

export type PageSizeSelectProps = {
  value: number;
  options?: number[];
  onValueChange: (value: number) => void;
  className?: string;
  container?: SelectPortalProps['container'];
};

export function PageSizeSelect({
  value,
  options = [10, 20, 50],
  onValueChange,
  className,
  container,
}: PageSizeSelectProps) {
  const { t } = useI18n();
  const id = useId();

  return (
    <div
      className={cn(
        'eye:body-s eye:flex eye:items-center eye:gap-8',
        className,
      )}
    >
      <Label className='eye:body-s eye:whitespace-nowrap' htmlFor={id}>
        {t('rowsPerPage')}
      </Label>
      <div className='eye:w-[93px]'>
        <Select
          id={id}
          aria-label={t('rowsPerPage')}
          value={String(value)}
          onValueChange={(next) => onValueChange(Number(next))}
          slotProps={{ portal: { container } }}
        >
          {options.map((option) => (
            <SelectItem key={option} value={String(option)}>
              {option}
            </SelectItem>
          ))}
        </Select>
      </div>
    </div>
  );
}
